const exemption_api_url = '/admin/security/create-csrf-tokenless-exemption';
import { Toast } from "../Notifications/Toast.js";

export class CsrfTokenlessRequestMaintenance extends HTMLElement
{
    constructor() {
        super();
    }

    connectedCallback()
    {
        this.init();
    }

    init()
    {
        this.initEventListeners();
    }

    initEventListeners()
    {
        const createExemptionButton = this.querySelector('#create-exemption-btn');

        if (createExemptionButton) {
            createExemptionButton.addEventListener('click', this.handleCreateExemptionButtonClick.bind(this));
        }
    }

    handleCreateExemptionButtonClick(event)
    {
        event.preventDefault();
        if (event.currentTarget.hasAttribute('disabled')) {
            return;
        }

        const statusElem = this.querySelector('select[name="status"]');
        if (statusElem && statusElem.value === 'approved') {
            return;
        }

        const modal = this.createExemptionModal();
        this.appendChild(modal);
        modal.showModal();
        modal.style.opacity = '1';
        const cancelButton = modal.querySelector('#cancel-exemption-button');
        const confirmButton = modal.querySelector('#confirm-exemption-button');

        cancelButton.addEventListener('click', () => {
            modal.close();
        });
        confirmButton.addEventListener('click', () => {
            if (this.handleExemptionCreation(modal)) {
                modal.close();
            }
        });
        modal.addEventListener('close', () => {
            modal.remove();
        });
    }

    createExemptionModal()
    {
        const routePatternInput = this.querySelector('input[name="route_pattern"]');
        if (routePatternInput) {
            routePatternInput.value = routePatternInput.value || '';
        }
        const methodInput = this.querySelector('input[name="method"]');
        if (methodInput) {
            methodInput.value = methodInput.value || '';
        }


        const modal = document.createElement('dialog');
        modal.id = 'create-exemption-modal';
        modal.innerHTML = `
            <h5>Create CSRF Tokenless Request Exemption</h5>
            <p class="exemption-info">Creating an exemption will allow requests matching the specified route pattern and method to bypass CSRF token verification. Please provide a reason for this exemption to ensure proper documentation and security auditing.</p>
            <form method="dialog">
                <p class="form-group"><label>Route Pattern:</label> <input type="text" disabled value="${routePatternInput ? routePatternInput.value : ''}"></p>
                <p class="form-group"><label>Method:</label> <input type="text" disabled value="${methodInput ? methodInput.value : ''}"></p>
                <p class="form-group"><label>Ticket Reference:</label> <input type="text" name="ticket_reference" ></p>
                <p class="form-group"><label>Reason:</label> <textarea rows="4" name="reason" required></textarea></p>
                <menu>
                    <button id="cancel-exemption-button" value="cancel">Cancel</button>
                    <button id="confirm-exemption-button" value="confirm">Create</button>
                </menu>
            </form>
        `;
        return modal;
    }

    handleExemptionCreation(modal)
    {
        const requestIdInput = this.querySelector('input[name="id"]');
        const reasonInput = modal.querySelector('textarea[name="reason"]');
        const routePatternInput = this.querySelector('input[name="route_pattern"]');
        const methodInput = this.querySelector('input[name="method"]');

        if (reasonInput && routePatternInput && methodInput) {
            const requestID = requestIdInput ? requestIdInput.value : null;
            const reason = reasonInput.value.trim();
            const routePattern = routePatternInput.value.trim();
            const method = methodInput.value.trim();
            const ticketReference = modal.querySelector('input[name="ticket_reference"]').value.trim();

            if (reason) {
                // Here you would typically send this data to the server to create the exemption
                const formData = new FormData();
                formData.append('request_id', requestID);
                formData.append('route_pattern', routePattern);
                formData.append('method', method);
                formData.append('reason', reason);
                formData.append('ticket_reference', ticketReference);

                fetch(exemption_api_url, {
                    method: 'POST',
                    body: formData
                }).then(response => {
                    if (response.ok) {
                        response.json().then(data => {
                            if (data.success) {
                                const statusElem = this.querySelector('select[name="status"]');
                                if (statusElem) {
                                    statusElem.value = data.status;
                                    statusElem.setAttribute('disabled', 'disabled');
                                }
                                const reviewedByElem = this.querySelector('input[name="reviewed_by"]');
                                if (reviewedByElem) {
                                    reviewedByElem.value = data.reviewed_by;
                                    reviewedByElem.setAttribute('disabled', 'disabled');
                                }

                                const reviewedAtElem = this.querySelector('input[name="reviewed_at"]');
                                if (reviewedAtElem) {
                                    reviewedAtElem.value = data.reviewed_at;
                                }

                                const linkedExemptionElem = this.querySelector('input[name="linked_exemption_id"]');
                                if (linkedExemptionElem) {
                                    linkedExemptionElem.value = data.exemption_id;
                                }

                                const createExemptionButton = this.querySelector('#create-exemption-btn');
                                if (createExemptionButton) {
                                    createExemptionButton.setAttribute('disabled', 'disabled');
                                }

                                const toast = new Toast({
                                    bodyContent: 'Exemption created successfully.',
                                    headerContent: "Exemption Created",
                                    delay: 5000, // 5 seconds
                                    containerClassList: ['exemption-toast-container'],
                                    hideOthers: true
                                });
                                toast.show();
                                return true;
                            } else {
                                const toast = new Toast({
                                    headerContent: 'Error',
                                    bodyContent: data.message,
                                    toastClassList: 'exemption-submission-error'
                                });
                                toast.show();
                            }
                        });
                        
                    } else {
                        const toast = new Toast({
                            headerContent: 'Error',
                            bodyContent: 'Error sending exemption submission.  Please try later',
                            toastClassList: 'exemption-submission-error'
                        });
                        toast.show();
                    }
                }).catch(error => {
                    const toast = new Toast({
                        headerContent: 'Error',
                        bodyContent: 'Error sending exemption submission.  Please try later',
                        toastClassList: 'exemption-submission-error'
                    });
                    toast.show();
            });

            } else {
                const toast = new Toast({
                    headerContent: 'Input Error',
                    bodyContent: 'Please enter a reason for the exemption',
                    toastClassList: 'exemption-submission-reason-error',
                    position: 'top-center'
                });
                toast.show();
                return false;
            }
        } else {
            alert('Missing required information. Please ensure all fields are filled out.');
            return false;
        }

        return true;
    }
}

customElements.define('csrf-tokenless-request-maintenance', CsrfTokenlessRequestMaintenance);